import { MenuItem, Stack } from '@mui/material';
import { BestPracticeSeverity } from './types';
import Severity from './Severity';
import SweepSelect, { SelectSizes } from '../common/SweepSelect';

const BestPracticeEditSeverity = ({
  severity,
  setSeverity,
  autoOpen,
}: {
  severity?: BestPracticeSeverity;
  setSeverity: (value: BestPracticeSeverity) => void;
  autoOpen?: boolean;
}) => {
  return (
    <SweepSelect
      variant={SelectSizes.small}
      autoOpen={autoOpen}
      SelectProps={{
        placeholder: 'Choose value',
        value: severity,
        onChange: (e) => setSeverity(e.target.value as BestPracticeSeverity),
        renderValue: (value) => (
          <Stack sx={{ position: 'relative', top: '2px' }}>
            <Severity severity={value as BestPracticeSeverity} variant="strong" />
          </Stack>
        ),
      }}
      MenuProps={{ PaperProps: { sx: { width: '177px' } } }}
    >
      <MenuItem value="High">
        <Severity severity="High" variant="strong" />
      </MenuItem>
      <MenuItem value="Medium">
        <Severity severity="Medium" variant="strong" />
      </MenuItem>
      <MenuItem value="Low">
        <Severity severity="Low" variant="strong" />
      </MenuItem>
    </SweepSelect>
  );
};

export default BestPracticeEditSeverity;
